import ActionTypes from "./types";

export const setOptionChainAction = (newState) => async (dispatch) =>
  await dispatch({
    type: ActionTypes.SET_OPTION_CHAIN_STATE,
    payload: newState,
  });



// WEBPACK FOOTER //
// ./src/actions/optionChainAction.js